import { getTimelineDetails } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineDetailsGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreTimelineDetails',
	receive: true,
	request: true,
	requestHandler: getTimelineDetails,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
